import React, { useState, useEffect, useRef } from "react";
import { Dropdown, FormControl } from "react-bootstrap";

import { EMPTY_STRING } from "../constants";

const CurrencyDropdown = (props) => {
  const {
    isFromTopbar,
    allCurrencies,
    isEditing = true,
    selectedCurrency = null,
    className = EMPTY_STRING,
    onCurrencyChange = () => {},
    buttonClass = EMPTY_STRING,
  } = props;

  const selectedItemRef = useRef(null);
  const dropdownMenuRef = useRef(null);
  const [show, setShow] = useState(false);
  const [currency, setCurrency] = useState(
    allCurrencies.find((currency) => Number(selectedCurrency) === currency?.id)
  );

  const [searchTerm, setSearchTerm] = useState("");

  const handleSelect = (eventKey) => {
    const selected = JSON.parse(eventKey);
    const shouldChange = onCurrencyChange(selected?.id);
    if (shouldChange !== false) {
      setCurrency(selected);
    }
    setShow(false);
  };

  const toggleDropdown = () => {
    if (!isEditing) {
      setShow(false);
    } else {
      setShow(!show);
    }
    setSearchTerm(""); // Clear search
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredCurrencies = allCurrencies.filter(
    (c) =>
      c.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
      c.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    setCurrency(
      allCurrencies.find(
        (currency) => Number(selectedCurrency) === currency?.id
      )
    );
  }, [selectedCurrency, allCurrencies]);

  useEffect(() => {
    if (show && selectedItemRef.current && dropdownMenuRef.current) {
      dropdownMenuRef.current.scrollTop =
        selectedItemRef.current.offsetTop - dropdownMenuRef.current.offsetTop;
    }
  }, [show]);

  return (
    <Dropdown
      show={show}
      onSelect={handleSelect}
      onToggle={toggleDropdown}
      className={`currency-dropdown ${
        !isEditing ? "not-editing" : EMPTY_STRING
      } ${className}`}
    >
      <Dropdown.Toggle
        variant="light"
        id="dropdown-basic"
        className={`align-items-center ${buttonClass}`}
        onClick={toggleDropdown}
      >
        {currency && (
          <div className="d-flex align-items-center gap-2">
            <img
              alt="currency icon"
              src={`${process.env.REACT_APP_CURRENCY_BASE_URL}${currency.code}.png`}
              width={24}
              height={16}
            />
            <span>{currency.code}</span>
          </div>
        )}{" "}
      </Dropdown.Toggle>

      <Dropdown.Menu
        className={`${isFromTopbar ? "dropdown-menu-left-100" : ""}`}
      >
        {/* Sticky Search Input */}
        <div className="p-2 search-wrapper">
          <FormControl
            autoFocus
            value={searchTerm}
            className="search-input"
            placeholder="Search currency..."
            onChange={handleSearchChange}
          />
        </div>

        {/* Scrollable Currency List */}
        <div className="currency-list-scroll" ref={dropdownMenuRef}>
          {filteredCurrencies.length > 0 ? (
            [...filteredCurrencies].map((c) => (
              <Dropdown.Item
                key={c.id}
                eventKey={JSON.stringify(c)}
                active={c.id === currency?.id}
                ref={c.id === currency?.id ? selectedItemRef : null}
              >
                <div className="d-flex align-items-center justify-content-between gap-2">
                  <div className="d-flex align-items-center gap-3">
                    <img
                      alt="currency icon"
                      src={`${process.env.REACT_APP_CURRENCY_BASE_URL}${c.code}.png`}
                      width={24}
                      height={16}
                    />
                    <div className="lh-sm">
                      <div className="currency-code">{c.code}</div>
                      <div className="currency-name">{c.name}</div>
                    </div>
                  </div>
                  <div>{c.symbol}</div>
                </div>
              </Dropdown.Item>
            ))
          ) : (
            <div className="px-3 py-2 text-center text-muted">
              No options
            </div>
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CurrencyDropdown;
